export default "__VITE_ASSET__BVX1b2UD__"